import {mapGetters, mapActions} from 'vuex'
const HeadSection = () => import(/* webpackChunkName: "c-head-section"*/ '@/components/HeadSection')

export default {
  name: 'app',
  components: {
    HeadSection
  },
  computed: {
    ...mapGetters(['visibleSideBar', 'visibleNavBar', 'currentUser']),
    ...mapGetters('Auth', ['currentUser', 'isLoggedIn']),
    isLoginPage () {
      return this.$route.path === '/login'
    },
    visibleSideBarApp () {
      return this.visibleSideBar && !this.isLoginPage
    }
  },
  methods: {
    ...mapActions(['setVisibleSideBar']),
    toggleMenu () {
      this.setVisibleSideBar(!this.visibleSideBar)
    }
  }
}